class PriceListDelegate {
    setChannel(channel) {
        this.setState((prevState) => {
            return { channel };
        });
    }

    setProducts(products) {
        this.setState((prevState) => {
            return { products };
        });
    }
}

export default PriceListDelegate;
